import { render, staticRenderFns } from "./WorkerCampusSingleSelect.vue?vue&type=template&id=50fbcb3d&scoped=true"
import script from "./WorkerCampusSingleSelect.vue?vue&type=script&lang=js"
export * from "./WorkerCampusSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./WorkerCampusSingleSelect.vue?vue&type=style&index=0&id=50fbcb3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbcb3d",
  null
  
)

export default component.exports